import axios from 'axios';
import { reportError } from '../../utils/error-handling-service';

const shopifyUrlBase = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production';

const isTugShopifyPath = organisationId => {
  if (organisationId === 'b847c281-d377-4528-a416-303234e382d8') {
    return '/tugenuff';
  }
  return '';
};

const getShopifyPath = (discussionId, discountCode, organisationId) => {
  const discountCodePath = discountCode ? `/${discountCode}` : '';
  return `/discussion/${discussionId}/shopify${isTugShopifyPath(organisationId)}/sales${discountCodePath}`;
};

const getShopifyOrdersByDiscussionIdUrl = (discussionId, discountCode, organisationId) =>
  `${shopifyUrlBase}${getShopifyPath(discussionId, discountCode, organisationId)}`;

const getShopifyOrdersByDiscussionId = ({ discussionId, discountCode, organisationId }) =>
  axios.get(getShopifyOrdersByDiscussionIdUrl(discussionId, discountCode, organisationId))
    .then(response => {
      const { data } = response;
      return data;
    }).catch(err => {
      reportError('Unknown error', err);
      return { data: { orders: [], error: err } };
    });

module.exports = {
  getShopifyOrdersByDiscussionId,
};




/** WEBPACK FOOTER **
 ** ./src/hocs/has-shopify/index.js
 **/